import React, { Component } from 'react';
import Slide from 'react-reveal/Slide'

class Skills extends Component {

    render() {
        return (
            <>
            <Slide right delay={100}>
            <div className="skills container my-5" id="skills">
                <div className="card">
                    <h4 className="text-muted text-center">My Skills</h4>
                    <hr/>
                    <ul className="list-group list-group-flush lead text-center">
                        <li className="list-group-item">Python</li>
                        <li className="list-group-item">SQL</li>
                        <li className="list-group-item">Computer Vision</li>
                        <li className="list-group-item">R programming</li>
                        <li className="list-group-item">Machine Learning</li>
                        <li className="list-group-item">NLP</li>
                    </ul>
                </div>
            </div>
            </Slide>
            </>
        );
    }
}

export default Skills;